import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	headingStyles: {
		paddingTop: token('space.075'),
		paddingBottom: token('space.075'),
		paddingLeft: token('space.300'),
		width: '400px',
	},
	headingTextStyles: {
		color: token('color.text.subtlest'),
		font: token('font.heading.xxsmall'),
		fontFamily: token('font.family.heading'),
		fontStyle: 'normal',
		fontWeight: token('font.weight.semibold'),
		display: 'flex',
		alignItems: 'center',
	},
});

type NestedViewHeadingProps = {
	heading: string;
	handleBack: () => void;
	handleBackHover?: () => void;
	handleBackLeave?: () => void;
};

export const NestedViewHeading = ({
	heading,
	handleBack,
	handleBackHover,
	handleBackLeave,
}: NestedViewHeadingProps): React.JSX.Element => {
	return (
		<Inline space="space.100" alignBlock="center" xcss={styles.headingStyles}>
			<IconButton
				icon={ArrowLeftIcon}
				label=""
				onClick={handleBack}
				onMouseEnter={handleBackHover}
				onMouseLeave={handleBackLeave}
				appearance="subtle"
			/>
			<Box xcss={styles.headingTextStyles}>{heading}</Box>
		</Inline>
	);
};
